import { ActionTree, Commit } from 'vuex';
import { StateInterface } from '../index';
import { OrderInfoInterface } from './state';


const actions: ActionTree<OrderInfoInterface, StateInterface> = {
  setOrderInfo({ commit }: { commit: Commit }, orderInfo : OrderInfoInterface) {
    commit('updateOrderInfo', orderInfo);
  }
};

export default actions;
